import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { useActiveMemberUpdate } from 'hooks';
import useMemberSettings from 'hooks/models/member/useMemberSettings';
import { t } from 'i18next';
import ReactJson from 'react-json-view';

export interface IMemberSettingsBlobDetailsProps {
  className?: string | object;
  onDelete: () => void;
}

const MemberSettingsBlobDetails = (props: IMemberSettingsBlobDetailsProps) => {
  const { className, onDelete } = props;
  const [updateKey] = useActiveMemberUpdate();
  const memberSettings = useMemberSettings();

  const deleteBlob = () => {
    updateKey('memberSettings', null);
    onDelete();
  };

  const classes = classNames('member-settings-blob m-6', className);

  return (
    <div className={classes}>
      <div>
        <h3>{t('Current member settings')}</h3>
        <ReactJson name={'Web Settings'} collapsed={true} src={memberSettings?.web ?? {}} />
        <ReactJson name={'Global Settings'} collapsed={true} src={memberSettings?.global ?? {}} />
      </div>
      <div className="mt-5">
        <h3>{t('Actions')}</h3>
        <Button onClick={deleteBlob} type="danger" className={'mt-4'}>
          {t('Delete All Settings')}
        </Button>
      </div>
    </div>
  );
};

export default MemberSettingsBlobDetails;
